import { PropertyAnnotation } from '../../model'

class Code extends PropertyAnnotation {}

Code.type = 'code'

export default Code
